module.exports = __webpack_public_path__ + "static/media/icon-14w.5b0e997d.svg";